import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { AUTH_USER } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AuthUserDataActionTypes, IAuthUser } from './types';
import api from 'src/utils/api';
import { push } from 'connected-react-router';
import { LocalStorageKeysEnum } from 'src/utils/enum';
import { PrivateRoutesEnum } from 'src/utils/router';
import { loadUserInit } from '../userInit/actions';

export const loadAuthUser =
  (
    auth: IAuthUser,
  ): ThunkAction<Promise<void>, State, null, AuthUserDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: AUTH_USER + REQUEST });
    try {
      const payload = await api.loadAuthUser(auth);
      localStorage.setItem(LocalStorageKeysEnum.TOKEN, payload.token);
      localStorage.setItem(LocalStorageKeysEnum.ID, payload.id);
      dispatch({ type: AUTH_USER + SUCCESS, payload });
      dispatch(loadUserInit());
      dispatch(push(PrivateRoutesEnum.DASHBOARD));
    } catch (error) {
      dispatch({ type: AUTH_USER + FAILURE, error });
    }
  };

export const statusIdle = () => ({ type: AUTH_USER + IDLE });
